var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgUsers = function SvgUsers(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10982_28517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2941 15.9035V14.3997C17.2936 13.7333 17.0718 13.0859 16.6636 12.5592C16.2553 12.0325 15.6836 11.6563 15.0384 11.4897",
    stroke: "white",
    strokeWidth: 1.50384,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7826 15.9036V14.3998C12.7826 13.6021 12.4657 12.8371 11.9017 12.273C11.3376 11.709 10.5726 11.3921 9.77491 11.3921H3.75956C2.96188 11.3921 2.19687 11.709 1.63282 12.273C1.06877 12.8371 0.751892 13.6021 0.751892 14.3998V15.9036",
    stroke: "white",
    strokeWidth: 1.50384,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0307 2.4668C12.6777 2.63245 13.2511 3.00871 13.6606 3.53626C14.0701 4.06381 14.2924 4.71265 14.2924 5.38048C14.2924 6.04831 14.0701 6.69715 13.6606 7.2247C13.2511 7.75225 12.6777 8.12851 12.0307 8.29416",
    stroke: "white",
    strokeWidth: 1.50384,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.76726 8.38449C8.42835 8.38449 9.77493 7.03791 9.77493 5.37681C9.77493 3.71572 8.42835 2.36914 6.76726 2.36914C5.10616 2.36914 3.75958 3.71572 3.75958 5.37681C3.75958 7.03791 5.10616 8.38449 6.76726 8.38449Z",
    stroke: "white",
    strokeWidth: 1.50384,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10982_28517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.046,
    height: 18.046,
    fill: "white",
    transform: "translate(0 0.113281)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUsers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/users.74aed394.svg";
export { ForwardRef as ReactComponent };